import { css } from 'styled-components';

export default css`
font-size: 14px;
color: #657480;
`;
